module.exports = __webpack_public_path__ + "static/media/name.d6273f59.svg";